import React from 'react';

const ClientName = (props) => {
    return (
        <h4 className="font-weight-bold client__name h5 mb-4 mb-md-9">{props.name}</h4>
    );
}

export default ClientName;